export default "__VITE_ASSET__C59XzeG8__"